export enum SD_Roles {
    ADMIN = "admin",
    CUTOMER = "customer",
  }
  
  export enum SD_Status {
    PENDING = "Pending",
    CONFIRMED = "Confirmed",
    BEING_COOKED = "Being Cooked",
    READY_FOR_PICKUP = "Out for Delivery",
    COMPLETED = "Completed",
    CANCELLED = "Cancelled",
  }
  
  export enum SD_Categories {
    MEALS = "Meals",
    TIFFEN = "Tiffen",
    FASTFOOD = "Fast Food",
    SNACKS = "Snacks",
  }
  
  export enum SD_SortTypes {
    PRICE_LOW_HIGH = "Price Low - High",
    PRICE_HIGH_LOW = "Price High - Low",
    NAME_A_Z = "Name A - Z",
    NAME_Z_A = "Name Z - A",
  }

  export enum SD_Bg{
    odd = "bg-light",
    even = "bg-secondary"
  }